import CryptoJS from 'crypto-js';

export const generateSignatureHeaders = () => {
  const secretKey = process.env.SECRET_KEY;
  if (!secretKey) {
    throw new Error('SECRET_KEY is not defined in environment');
  }

  const timestamp = Date.now().toString();
  const encrypted = CryptoJS.AES.encrypt(timestamp, secretKey).toString();

  return {
    'x-token': encrypted
  };
};
